module.exports = __webpack_public_path__ + "static/media/entiga.0dd033cc.png";